import { DialogTitle } from '@headlessui/react';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import Modal from '../../../widgets/Modal';
import Button from '../../../widgets/Button';
import { useMfaModalContext } from '../../../../shared/providers/MfaModalProvider';
import { supportMessage } from '../../../../shared/service/auth';

import mfaVisual from '../../../../assets/icons/mfa/mfa-visuals.png';
import useAuth from '../../../../utilities/hooks/useAuth';

function PromptModal({
  enabled,
  userData,
}: {
  enabled: boolean;
  userData: any;
}) {
  const { setSupportMessageSent, setPromptAlertModal } = useMfaModalContext();
  const { t } = useTranslation();
  const { selfData } = useAuth();

  const uData = {
    name: userData?.name,
    message: 'REQUESTED FOR RESETING THEIR TWO-FACTOR AUTHENTICATION',
    token: userData?.token,
    action: 'MFA-SUPPORT',
  };

  const { mutate: refetchMfaSupportMessage } = useMutation({
    mutationKey: ['mfaSupportMessage'],
    mutationFn: () => supportMessage(uData),
    onSuccess: (response: any) => {
      if (response?.data?.data) {
        setSupportMessageSent(true);
      }
    },
    onError: () => {},
  });

  return (
    <Modal
      open={enabled}
      closeButton
      handleClose={() => setPromptAlertModal(false)}
      modalClassName="max-w-[500px] w-full px-[32px] py-[36px] pt-[120px] intl-2fa-modal"
    >
      <div className="justify-center text-center focus:ring-3">
        <img
          src={mfaVisual}
          className="m-auto mb-20 w-[214px]"
          alt="Mfa visuals"
        />
        <DialogTitle
          as="h4"
          className="text-black-900 mb-2 text-lg font-semibold"
        >
          {t('RESET_2FA_HEADER')}
        </DialogTitle>
        <span className="text-black-600 mb-[10px] block text-xs">
          {t('RESET_2FA_SUBHEADER')}
        </span>
        <Button
          size="lg"
          className={'mx-auto mt-8'}
          onClick={() => {
            setPromptAlertModal(false);
            refetchMfaSupportMessage();
          }}
        >
          {t('RESET_2FA_CTA')}
        </Button>
      </div>
    </Modal>
  );
}

export default PromptModal;
